import { render, staticRenderFns } from "./adopet.vue?vue&type=template&id=05c8a41f&scoped=true&"
import script from "./adopet.vue?vue&type=script&lang=js&"
export * from "./adopet.vue?vue&type=script&lang=js&"
import style0 from "./adopet.vue?vue&type=style&index=0&id=05c8a41f&prod&lang=css&"
import style1 from "./adopet.css?vue&type=style&index=1&id=05c8a41f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c8a41f",
  null
  
)

export default component.exports